import axios, { AxiosInstance } from 'axios';
import { API_STAGE_MAP } from 'src/constants/ApiConstants';

let gtcServiceClient: ApiClient;

export function getGtcHubClientInstance(): ApiClient {
  if (!gtcServiceClient) {
    const taaEnablementStageConfig = `${window.location.origin}/api/${API_STAGE_MAP['prod']}`;
    gtcServiceClient = new ApiClient(taaEnablementStageConfig);
  }

  return gtcServiceClient;
}

export interface MetaData {
  apiName?: string;
  component?: string;
  startTime?: number;
}

declare module 'axios' {
  interface AxiosRequestConfig {
    meta?: MetaData | undefined;
  }
}

export class ApiClient {
  readonly client: AxiosInstance;

  constructor(apiBaseUrl: string) {
    this.client = axios.create({
      baseURL: apiBaseUrl,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
      },
      responseType: 'json',
    });

    this.client.interceptors.request.use((request) => {
      request.meta = request.meta ?? {};
      request.meta.startTime = Date.now();
      // TODO add metric & log
      return request;
    });

    this.client.interceptors.response.use(
      (response) => {
        // TODO add metric & log
        return response.data;
      },
      (error) => {
        // TODO add metric & log
        return Promise.reject(error);
      },
    );
  }
}
export {};
